import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationOilDiscountCounter } from '@/api/bairun/financialCenter';
import NP from 'number-precision';
import { mapGetters } from 'vuex';
import dateUtils from '@/utils/dateUtil';
export default {
  name: 'SlotCounterStationPlatformPromotion',
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    totalId: {
      type: Number,
      default: 999
    },
    refIndex: {
      type: Number,
      required: true
    },
    sheetType: {
      type: String,
      required: true
    },
    slotCounterName: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      slotOption: '',
      selectedOilCode: '92',
      selectedArea: '全部',
      dayNums: 0,
      monthNums: 0,
      daySumSvcNums: 0,
      daySumUserNums: 0,
      daySumPlatformNums: 0,
      monthSumSvcNums: 0,
      monthSumUserNums: 0,
      monthSumPlatformNums: 0,
      stationDailyPlatformDiscountData: [],
      tempGroupData: {},
      borderFix: ['合计/L', '合/L', '92#均价', '95#均价', '0#均价'],
      cellColClassFix: ['dayDiffPrice', 'monthDiffPrice'],
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      showStations: [],
      customColors: [{
        color: '#909399',
        percentage: 30
      }, {
        color: '#f56c6c',
        percentage: 60
      }, {
        color: '#e6a23c',
        percentage: 85
      }, {
        color: '#409eff',
        percentage: 99
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      excelSheets: [{
        tableId: 'stationDailyPlatformDiscountData',
        name: '平台优惠价差报表',
        tableRows: 2
      }]
    };
  },
  watch: {
    end: function end() {
      this.loadData();
    },
    refIndex: function refIndex() {
      this.refIndexRefresh();
    }
  },
  computed: _objectSpread({}, mapGetters(['sellerId', 'allowedStations'])),
  created: function created() {
    this.loadData();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs['stationDailyPlatformDiscountData'].doLayout();
    });
  },
  methods: {
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }

      if (this.cellColClassFix.includes(column.property)) {
        return 'background: #ffe9cf';
      }
    },
    refIndexRefresh: function refIndexRefresh() {
      this.$refs['stationDailyPlatformDiscountData'].doLayout();
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];
      var sums2 = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          sums2[index] = '合计';
          return;
        }

        var values;
        var values2;

        if (column.property === 'dayDiffPrice92') {
          values = data.map(function (item) {
            return NP.times(item['dayDiscount92'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['dayNums92'], 1);
          });
        } else if (column.property === 'dayDiffPrice95') {
          values = data.map(function (item) {
            return NP.times(item['dayDiscount95'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['dayNums95'], 1);
          });
        } else if (column.property === 'dayDiffPrice0') {
          values = data.map(function (item) {
            return NP.times(item['dayDiscount0'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['dayNums0'], 1);
          });
        } else if (column.property === 'monthDiffPrice92') {
          values = data.map(function (item) {
            return NP.times(item['monthDiscount92'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['monthNums92'], 1);
          });
        } else if (column.property === 'monthDiffPrice95') {
          values = data.map(function (item) {
            return NP.times(item['monthDiscount95'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['monthNums95'], 1);
          });
        } else if (column.property === 'monthDiffPrice0') {
          values = data.map(function (item) {
            return NP.times(item['monthDiscount0'], 1);
          });
          values2 = data.map(function (item) {
            return NP.times(item['monthNums0'], 1);
          });
        } else {
          values = data.map(function (item) {
            return Number(item[column.property]);
          });
          values2 = data.map(function (item) {
            return Number(item[column.property]);
          });
        }

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = NP.round(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }

        if (!values2.every(function (value) {
          return isNaN(value);
        })) {
          sums2[index] = values2.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums2[index] = NP.round(sums2[index], 2);
        } else {
          sums2[index] = 'N/A';
        }
      });
      sums[4] = sums[2] > 0 ? NP.round(NP.divide(sums[3], sums[2]), 2) : '-';
      sums[5] = sums2[5] > 0 ? NP.round(NP.divide(sums[5], sums2[5]), 2) : '-';
      sums[6] = sums2[6] > 0 ? NP.round(NP.divide(sums[6], sums2[6]), 2) : '-';
      sums[7] = sums2[7] > 0 ? NP.round(NP.divide(sums[7], sums2[7]), 2) : '-';
      sums[11] = sums[9] > 0 ? NP.round(NP.divide(sums[10], sums[9]), 2) : '-';
      sums[12] = sums2[12] > 0 ? NP.round(NP.divide(sums[12], sums2[12]), 2) : '-';
      sums[13] = sums2[13] > 0 ? NP.round(NP.divide(sums[13], sums2[13]), 2) : '-';
      sums[14] = sums2[14] > 0 ? NP.round(NP.divide(sums[14], sums2[14]), 2) : '-';
      return sums;
    },
    loadData: function loadData() {
      var _this2 = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: null,
          name: this.slotCounterName,
          start: this.end / 1000 - 24 * 60 * 60,
          end: this.end / 1000,
          search: this.totalId === 999 ? '' : this.totalId.toString()
        }]
      };
      getStationOilDiscountCounter(descriptorData).then(function (response) {
        _this2.stationDailyPlatformDiscountData = Object.values(response.data).sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        }); // console.log('this.stationDailyPlatformDiscountData', this.stationDailyPlatformDiscountData)

        _this2.loading = false;
        _this2.sheetUnLoadCount = 0;

        _this2.$refs['stationDailyPlatformDiscountData'].doLayout();
      }).catch(function () {
        _this2.loading = false;
      });
    },
    timestamp2datestring: function timestamp2datestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return dateUtils.timeStampToString(ts, format);
    }
  }
};